import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { LogService } from './log.service';
import { EventconfigStoreService } from './eventconfig-store.service';
import { environment } from '../../environments/environment';

new HttpHeaders({ 'Content-Type': 'application/json' });

@Injectable({
  providedIn: 'root'
})
export class QuestionStoreService {

  private http: HttpClient = inject(HttpClient);
  private logger: LogService = inject(LogService);
  private es: EventconfigStoreService = inject(EventconfigStoreService);

  private nodeServiceUrl = environment.production ? "event-backend" : "test-event-backend";

  getAllPaginationNew(): Observable<any> {
    return this.http.post(environment.apiUrl + `/v1/${this.nodeServiceUrl}/questions/getQuestionsVoD_v2`, {});
  }

  /**
   * Fragen-Konfiguration aus dem Event-Dokument (Customer_{slug}.events), u.a. das
   * Zeichenlimit — dieselbe Quelle, gegen die das Backend beim Absenden validiert.
   * charLimit === null heißt: Limit in der CCP deaktiviert.
   * POST wie die übrigen Lese-Aufrufe hier, damit unterwegs nichts gecacht wird
   * (der Wert wird für Live-Updates gepollt).
   */
  getQuestionsConfig(): Observable<{ charLimit: number | null }> {
    return this.http.post<{ charLimit: number | null }>(environment.apiUrl + `/v1/${this.nodeServiceUrl}/questions/config`, {});
  }

  sendMsgNew(message, languages:string[] = [],userSeeQuestion:boolean = false): Observable<any> {
    return this.http.post<any>(environment.apiUrl + `/v1/${this.nodeServiceUrl}/questions/newQuestion`, {
      customer: environment.customerShort,
      mess_text: message.msgText,
      mess_author: message.author,
      mess_location: message.location,
      languages:userSeeQuestion ? languages : [],
    });
  }

  voteUAQ(id): Observable<any> {
    return this.http.post<any>(environment.apiUrl + `/v1/${this.nodeServiceUrl}/questions/upvoteQuestion`, {
      id: id
    });
  }

  private getVotesKey(): string {
    const token = this.es.token ?? '';
    return `votes_${token}`;
  }

  saveVotes(id) {
    const key = this.getVotesKey();
    const stored = localStorage.getItem(key);
    let votes = [];
    this.logger.log('saveVotes ' + id);
    if (stored !== null && JSON.parse(stored) !== null) {
      votes = JSON.parse(stored);
    }
    this.logger.log('saveVotes ' + votes);
    votes.push(id);
    localStorage.setItem(key, JSON.stringify(votes));
    return votes;
  }

  getVotes() {
    const stored = localStorage.getItem(this.getVotesKey());
    return stored !== null ? JSON.parse(stored) : null;
  }
  questionCount: number = 0;

  get questionsCount(): number {
    return this.questionCount
  }
  set questionsCount(count: number) {
    this.questionCount = count;
  }

}
